import {Action, Argument} from "../../../feature/project/Shot";
import {Button, Dropdown, Flex, Input, MenuProps, Modal, Popover, Space, Typography} from "antd";
import React, {useEffect, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleDown, faImage} from "@fortawesome/free-solid-svg-icons";
import {MenuItemType} from "antd/es/menu/interface";
import {AssetsBrowser} from "./AssetsBrowser";
import {Asset} from "../../../feature/project/fields";
import {Description} from "../../../typography/Description";

export const ArgumentEditDialog = (
    props: {
        action: Action;
        arg: Argument;
        onSave: (argument: Argument) => void;
        onCancel: () => void;
    }
) => {
    const isSoundAction = props.action.arguments.filter((argument) => argument.title == "playSound").length > 0
    const [arg, setArg] = useState(props.arg)
    const [hasChanged, setHasChanged] = useState(false)
    const [title, setTitle] = useState(props.arg.title)
    const [type, setType] = useState(props.arg.type)
    const [value, setValue] = useState(props.arg.value)
    const [assetBrowser, setAssetBrowser] = useState(false)

    useEffect(() => {
            setHasChanged(props.arg.title !== title || props.arg.type !== type || props.arg.value !== value)
        }, [props.arg, arg, title, type, value]
    )

    const types: MenuProps = {
        items: [
            {
                label: "Variable",
                key: "variable" //e.g. set variable - "value", increment - "{variableName}+1"
            },
            {
                label: "Parameter",
                key: "parameter" //e.g. logical parameter - name: when, value: start, name: delay, value: 1000
            },
            {
                label: "Execute",
                key: "execute" //e.g. play sound - "sound:assetId:delay", move to shot - "shot:shotId"
            },
        ],
        onClick: (item) => {
            setType(item.key)
        }
    }

    const executes: MenuProps = {
        items: [
            {
                label: "Play Sound",
                key: "playSound"
            },
            {
                label: "Stop Sound",
                key: "stopSound"
            },
            {
                label: "Jump To",
                key: "jumpTo"
            },
        ],
        onClick: (item) => {
            setTitle(item.key)
        }
    }

    const soundParameters: MenuProps = {
        items: [
            {
                label: "Delay",
                key: "delay"
            },
            {
                label: "Volume",
                key: "volume"
            },
            {
                label: "Repeat",
                key: "repeat"
            },
        ],
        onClick: (item) => {
            setTitle(item.key)
        }
    }

    return (
        <Modal
            open={true}
            title={props.arg.id ? 'Edit Argument' : 'Add Argument'}
            width={400}
            okText={'Save'}
            cancelText={'Close'}
            onCancel={props.onCancel}
            okButtonProps={
                {
                    disabled: !hasChanged
                }
            }
            onOk={() => {
                props.onSave(
                    {
                        ...props.arg,
                        title: title,
                        type: type,
                        value: value
                    })
            }
            }
        >
            <Flex gap={16}>
                <Space direction={'vertical'}
                       style={{width: '100%', maxHeight: 400, overflowY: 'auto', scrollbarWidth: "none"}}
                       size={16}>
                    <div>
                        <Typography style={{fontWeight: 700}}>Name</Typography>
                        {type === "execute" ?
                            <Dropdown
                                menu={executes} trigger={["click"]}>
                                <Button style={{width: '100%'}}>
                                    <Flex align={'center'}
                                          style={{width:"100%"}}
                                          justify={'space-between'}> {title ? (executes.items?.find((item) => item?.key == title) as MenuItemType)?.label : "Select Name"}
                                        <FontAwesomeIcon icon={faAngleDown}/></Flex>
                                </Button>
                            </Dropdown>
                            :
                            type === "parameter" ?
                                isSoundAction ?
                                    <Dropdown
                                        menu={soundParameters} trigger={["click"]}>
                                        <Button style={{width: '100%'}}>
                                            <Flex align={'center'}
                                                  style={{width:"100%"}}
                                                  justify={'space-between'}> {title ? (soundParameters.items?.find((item) => item?.key == title) as MenuItemType)?.label : "Select Name"}
                                                <FontAwesomeIcon icon={faAngleDown}/></Flex>
                                        </Button>
                                    </Dropdown>
                                    :
                                    <Input value={title} onChange={(e) => setTitle(e.target.value)}/>
                                :
                                <Input value={title} onChange={(e) => setTitle(e.target.value)}/>
                        }

                    </div>
                    <div>
                        <Typography style={{fontWeight: 700}}>Type</Typography>
                        <Dropdown
                            menu={{
                                ...types, items: types.items?.filter(item => {
                                    return (isSoundAction && item?.key == "parameter") || !isSoundAction
                                })
                            }} trigger={["click"]}>
                            <Button style={{width: '100%'}}>
                                <Flex align={'center'}
                                      style={{width:"100%"}}
                                      justify={'space-between'}> {type ? (types.items?.find((item) => item?.key == type) as MenuItemType)?.label : "Select Type"}
                                    <FontAwesomeIcon icon={faAngleDown}/></Flex>
                            </Button>
                        </Dropdown>
                    </div>
                    <div>
                        <Typography style={{fontWeight: 700}}>Value</Typography>
                        <Flex gap={8}>
                            <div style={{flexGrow: 1}}>
                                <Input style={{flexGrow: 1}} value={value} onChange={(e) => setValue(e.target.value)}
                                       allowClear={true}/>
                                {type == 'parameter' && title == 'repeat' ?
                                    <Description value={"Set 0 for infinite loop"}/>
                                    : ""}
                            </div>
                            {type == ''}
                            <Popover
                                onOpenChange={setAssetBrowser}
                                open={assetBrowser}
                                trigger={'click'}
                                placement={'rightTop'}
                                overlayInnerStyle={{marginTop: -10}}
                                arrow={false}
                                content={
                                    <AssetsBrowser
                                        categories={['Location', 'Geography']}
                                        onAssetSelected={(asset: Asset | null) => {
                                            setValue(asset ? asset.content : "")
                                            setAssetBrowser(false)
                                        }}
                                    />
                                }
                            >
                                <Button
                                    onClick={() => {
                                        setAssetBrowser(true)
                                    }}
                                >
                                    <FontAwesomeIcon icon={faImage}/>
                                </Button>
                            </Popover>
                        </Flex>
                    </div>
                </Space>
            </Flex>

        </Modal>
    );
}